import { Text } from '@thanx/uikit/text'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import escape from 'lodash/escape'
import React from 'react'
import { useStyletron } from 'styletron-react'
import { ACTIVATION_AGREEMENT_LINKS } from './constants'

const t = buildTranslate('recovery_ai.activation.pricing_modal.agreement')

type Props = {
  merchantName?: string
}

// The consent paragraph the admin attests to before the audited activate PUT fires.
// The legal-document link is inline in the prose, so the anchor lives in the
// locale string and only the URL + the link class are interpolated — the established
// idiom in this repo (see locales/merchantUsers.ts, emails.ts, setup.ts).
const ActivationAgreement = ({ merchantName }: Props) => {
  const [css] = useStyletron()
  const linkClass = css({
    color: palette.belizeHole,
    textDecoration: 'underline',
  })

  // buildTranslate is a bare I18n.t passthrough and react-i18nify does NOT escape
  // interpolations, so the merchant name — which lands inside dangerouslySetInnerHTML
  // below — must be escaped by hand.
  const body = t('body', {
    merchant: escape(merchantName || t('merchant_fallback')),
    serviceTermsUrl: ACTIVATION_AGREEMENT_LINKS.serviceTerms,
    linkClass,
  })

  return (
    <div>
      <Text.BodyText4 tag="div" bold color="grey90">
        {t('label')}
      </Text.BodyText4>
      <Text.BodyText4 tag="div" color="grey70" className="mt-xs">
        {/* eslint-disable-next-line react/no-danger */}
        <span dangerouslySetInnerHTML={{ __html: body }} />
      </Text.BodyText4>
    </div>
  )
}

export default ActivationAgreement
